import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  cancelCheckoutModalController: [
    'runtimeConstant',
    '$scope',
    'revisionListService',
    function (runtimeConstant, $scope, revisionListService) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function questionModal() {
        var ids = $scope.docs.map((r) => r.id);
        return new Promise((resolve) => {
          revisionListService
            .cancelCheckout(ids)
            .then(() => {
              for (var i = 0; i < $scope.docs.length; i++) {
                var rev = $scope.docs[i];
                rev.revisionCheckout = null;
                rev.idStatus = 1;
                rev.updatePermissions();
              }
              resolve();
              $scope.modalRemoveDocument.close();
            })
            .catch((err) => {
              swal.insertQueueStep({
                title: err.error,
                text: err.errorDescription,
                icon: 'error',
              });
              resolve();
            });
        });
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};